import React, { startTransition, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  documentNamesState,
  excludeDocumentNamesState,
  userState,
} from "../../../states/userState";
import { WithOutContext as ReactTags } from "react-tag-input";
import classes from "./CreateDocumentTags.module.scss";
import {
  foreColorCode,
  foreColorPagination,
  foreColorPaginationError,
} from "../../../commons/colors";
import { Divider } from "@mui/material";
import classNames from "classnames";
const CreateDocumentTags = () => {
  const [documentNames, setDocumentNames] = useRecoilState(documentNamesState);
  const [excludeDocumentNames, setExcludeDocumentNames] = useRecoilState(
    excludeDocumentNamesState
  );
  const [documentNamesForUi, setDocumentNamesForUi] = useState(documentNames);
  const [excludeDocumentNamesForUi, setExcludeDocumentNamesForUi] =
    useState(excludeDocumentNames);
  const user = useRecoilValue(userState);
  const isLiteMode = user?.mode === "lite";
  const inputKeywordClassName = classNames(classes.keywordInput, {
    [classes.keywordInputLight]: isLiteMode,
    [classes.keywordInputDark]: !isLiteMode,
  });
  const inputExcludeKeywordClassName = classNames(classes.excludeKeywordInput, {
    [classes.excludeKeywordInputLight]: isLiteMode,
    [classes.excludeKeywordInputDark]: !isLiteMode,
  });
  //キーワードで絞るタグの登録
  const handleAdditionDocumentName = (tag) => {
    // 入力された文字列を分割 (半角/全角スペース、半角/全角カンマ)
    const splittedTexts = tag.text
      .split(/[\s\u3000,、]+/) // 正規表現で複数の区切り文字に対応
      .map((t) => t.trim()) // 前後の空白を除去
      .filter(Boolean); // 空文字列を除去

    // 既に10個あるなら何もしない
    // または「残りのスロットがある分だけ追加」する形に変えてもOK
    if (documentNames.length >= 10) return;

    // ステートに一つずつ追加する（10個以上は追加しない）
    setDocumentNamesForUi((currentNames) => {
      const result = [...currentNames];
      splittedTexts.forEach((text) => {
        if (result.length < 10) {
          result.push(text);
        }
      });
      return result;
    });

    // startTransitionでまとめて更新
    startTransition(() => {
      setDocumentNames((currentNames) => {
        const result = [...currentNames];
        splittedTexts.forEach((text) => {
          if (result.length < 10) {
            result.push(text);
          }
        });
        return result;
      });
    });
  };

  const handleDeleteDocumentName = (index) => {
    setDocumentNamesForUi(documentNamesForUi.filter((_, i) => i !== index));
    startTransition(() => {
      setDocumentNames(documentNames.filter((_, i) => i !== index));
    });
  };
  //キーワードで除外するタグの登録
  const handleAdditionExcludeDocumentName = (tag) => {
    const splittedTexts = tag.text
      .split(/[\s\u3000,、]+/)
      .map((t) => t.trim())
      .filter(Boolean);

    if (excludeDocumentNames.length >= 10) return;

    setExcludeDocumentNamesForUi((currentNames) => {
      const result = [...currentNames];
      splittedTexts.forEach((text) => {
        if (result.length < 10) {
          result.push(text);
        }
      });
      return result;
    });

    startTransition(() => {
      setExcludeDocumentNames((currentNames) => {
        const result = [...currentNames];
        splittedTexts.forEach((text) => {
          if (result.length < 10) {
            result.push(text);
          }
        });
        return result;
      });
    });
  };

  const handleDeleteExcludeDocumentName = (index) => {
    setExcludeDocumentNamesForUi(
      excludeDocumentNamesForUi.filter((_, i) => i !== index)
    );
    startTransition(() => {
      setExcludeDocumentNames(
        excludeDocumentNames.filter((_, i) => i !== index)
      );
    });
  };
  return (
    <div className={classes.root}>
      <p
        className={classes.name}
        style={foreColorPagination(user?.mode ?? "lite")}
      >
        文書名
      </p>
      <Divider
        textAlign="left"
        sx={dividerStyle(
          user?.mode === "lite" ? foreColorCode("lite") : foreColorCode("dark")
        )}
        variant="fullWidth"
      ></Divider>
      <div className={classes.mainContainer}>
        <div className={classes.keywordContainer}>
          <p
            className={classes.keywordTitle}
            style={foreColorPagination(user?.mode ?? "lite")}
          >
            キーワードで絞る
          </p>
          <div>
            <ReactTags
              handleAddition={handleAdditionDocumentName}
              handleDelete={() => {}}
              placeholder="制作 先行図 先行手配 .."
              classNames={{
                tagInput: classes.keyword, // <div> のラッパに付くクラス
                tagInputField: inputKeywordClassName, // <input> 自体に付くクラス
                tag: classes.tag, // タグ本体
                remove: classes.tagRemove, // タグの削除ボタン
              }}
            />
            <div className={classes.tagContainer}>
              {documentNamesForUi.map((k, i) => (
                <div
                  key={i}
                  className={classes.tag}
                  onClick={() => handleDeleteDocumentName(i)}
                >
                  <span>{k}</span>
                  <span className="cursor-pointer">x</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={classes.keywordContainer}>
          <p
            className={classes.keywordTitle}
            style={foreColorPaginationError(user?.mode ?? "lite")}
          >
            キーワードを除外する
          </p>
          <div>
            <ReactTags
              handleAddition={handleAdditionExcludeDocumentName}
              handleDelete={() => {}}
              placeholder="制作 先行図 先行手配 .."
              classNames={{
                tagInput: classes.keyword, // <div> のラッパに付くクラス
                tagInputField: inputExcludeKeywordClassName, // <input> 自体に付くクラス
                tag: classes.tag, // タグ本体
                remove: classes.tagRemove, // タグの削除ボタン
              }}
            />
            <div className={classes.tagContainer}>
              {excludeDocumentNamesForUi.map((k, i) => (
                <div
                  key={i}
                  className={classes.excludeTag}
                  onClick={() => handleDeleteExcludeDocumentName(i)}
                >
                  <span>{k}</span>
                  <span className="cursor-pointer">x</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const dividerStyle = (color) => {
  let styles = {
    borderColor: `${color}`, // 線の色をテーマのプライマリーカラーに設定
    fontSize: "18px",
    marginBottom: "10px",
    // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
    "&::before, &::after": {
      // Dividerの線のスタイルをカスタマイズ
      borderTopColor: `${color}`, // これにより、線の色が変わります
    },
    color: `${color}`, // テキストの色を変更
    "@media (max-width: 600px)": {
      fontSize: "14px", // フォントサイズを14pxに設定
    },
  };
  return styles;
};
export default CreateDocumentTags;
